import TransactionDetail from "./Payment/components/TransactionDetail";
import EditAccountInfo from "./Account/components/EditAccountInfo";
import { selectLogOutModal } from "../../store/auth/selectors";
import VideoPlayer from "./JobsHistory/components/VideoPlayer";
import LogOut from "../../containers/LogOut";
import PersonalEmailWarning from "../../containers/PersonalEmailWarning";
import { selectPersonalEmailWarningModal } from "../../store/signUp/selectors";
import AddExtraApplicant from "./Account/components/AddExtraApplicant";
import AddExtraJobPost from "./Account/components/AddExtraJobPost";
import ExaminerReport from "./JobsHistory/containers/ExaminerReport";
import RecruitingInterviewReport from "./JobsHistory/containers/RecruitingInterviewReport";
import ContactSales from "./Payment/components/ContactSales";
import ConfirmCancelSubscription from "./Payment/components/ConfirmCancelSubscription";
import JobDetail from "./JobsHistory/containers/JobDetail";
import ChangePassword from "./Account/components/ChangePassword";
import InviteMember from "./Account/components/InviteMember";
import ConfirmLeaveOrganization from "./Account/components/ConfirmLeaveOrganization";
import ConfirmJoinOrganization from "./Account/components/ConfirmJoinOrganization";
import ConfirmRemoveMember from "./Account/components/ConfirmRemoveMember";
import AddExtraMember from "./Account/components/AddExtraMember";
import ExtraServicesPayment from "./Account/containers/ExtraServicesPayment";
import EditJobExamDeadline from "./JobsHistory/containers/EditJobExamDeadline";
import CopyJobLinkWarning from "../../containers/CopyJobLinkWarning";
import VideoUploadIssue from "./JobsHistory/containers/VideoUploadIssue";
import PreparingExams from "../../containers/PreparingExams";
import ContactAdmin from "../../containers/ContactAdmin";
import ExamShareGuide from "../../containers/ExamShareGuide";
import EditPhoneNumber from "./Account/components/EditPhoneNumber";
import EditCompanyInfo from "./Account/components/EditCompanyInfo";
import ChangePlan from "./Account/components/ChangePlan";
import IncompleteProfile from "../../containers/IncompleteProfile";
import UploadCompanyLogo from "./Account/components/UploadLogo";
import ExaminerProfile from "./JobsHistory/containers/ExaminerProfile";
import AddNewCard from "./Payment/components/AddNewCard";
import ConfirmEndExam from "./JobsHistory/components/ConfirmEndExam";
import WorkspaceLayout from "../../layouts/Workspace";
import { useDispatch, useSelector } from "../../store/store";
import DeleteCard from "./Payment/components/DeleteCard";
import EditCard from "./Payment/components/EditCard";
import PurchasePlan from "./Payment/components/PurchasePlan";
import PlansModal from "./Payment/components/PlansModal";
import EditEmail from "./Account/components/EditEmail";
import ChooseCard from "./Payment/components/ChooseCard";
import { getUserInfoThunk } from "../../store/auth/thunks";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Outlet } from 'react-router-dom';
import { useEffect } from "react";
import {
    getJobsThunk,
    getLogoImageThunk,
    getProfileDataThunk,
    getUserAttributesThunk,
    getStripeCustomerThunk,
} from "../../store/workspace/thunks";
import {
    selectProfile,
    selectEditCardModal,
    selectPlansModalShow,
    selectStripeCustomer,
    selectAddNewCardModal,
    selectDeleteCardModal,
    selectChangePlanModal,
    selectCompanyLogoModal,
    selectPurchasePlanModal,
    selectConfirmEndExamModal,
    selectEditAccountInfoModal,
    selectExaminerProfileModal,
    selectEditCompanyInfoModal,
    selectTransactionDetailModal,
    selectIncompleteProfileModal,
    selectChooseCreditCardModalModal,
    selectVideoPlayerModal,
    selectExaminerReportModal,
    selectRecruitingInterviewReportModal,
    selectContactSalesModal,
    selectConfirmCancelSubscriptionModal,
    selectJobDetailModal,
    selectChangePasswordModal,
    selectInviteMemberModal,
    selectConfirmJoinOrganizationModal,
    selectConfirmRemoveMemberModal,
    selectContactAdminModal,
    selectExamShareGuideModal,
    selectEditPhoneNumberModal,
    selectConfirmLeaveOrganizationModal,
    selectEditEmailModal,
    selectAddExtraApplicantModal,
    selectAddExtraJobPostModal,
    selectAddExtraMemberModal,
    selectExtraServicesPaymentModal,
    selectEditJobExamDeadlineModal,
    selectPreparingExamsModal,
    selectCopyJobLinkWarningModal,
    selectVideoUploadIssueModal,
} from "../../store/workspace/selectors";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY || '123');

function Workspace() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const logOutModal = useSelector(selectLogOutModal);
    const editCardModal = useSelector(selectEditCardModal);
    const stripeCustomer = useSelector(selectStripeCustomer);
    const plansModalShow = useSelector(selectPlansModalShow);
    const jobDetailModal = useSelector(selectJobDetailModal);
    const editEmailModal = useSelector(selectEditEmailModal);
    const addNewCardModal = useSelector(selectAddNewCardModal);
    const deleteCardModal = useSelector(selectDeleteCardModal);
    const changePlanModal = useSelector(selectChangePlanModal);
    const companyLogoModal = useSelector(selectCompanyLogoModal);
    const videoPlayerModal = useSelector(selectVideoPlayerModal);
    const contactSalesModal = useSelector(selectContactSalesModal);
    const purchasePlanModal = useSelector(selectPurchasePlanModal);
    const inviteMemberModal = useSelector(selectInviteMemberModal);
    const contactAdminModal = useSelector(selectContactAdminModal);
    const confirmEndExamModal = useSelector(selectConfirmEndExamModal);
    const examinerReportModal = useSelector(selectExaminerReportModal);
    const examShareGuideModal = useSelector(selectExamShareGuideModal);
    const changePasswordModal = useSelector(selectChangePasswordModal);
    const addExtraMemberModal = useSelector(selectAddExtraMemberModal);
    const preparingExamsModal = useSelector(selectPreparingExamsModal);
    const editPhoneNumberModal = useSelector(selectEditPhoneNumberModal);
    const examinerProfileModal = useSelector(selectExaminerProfileModal);
    const editAccountInfoModal = useSelector(selectEditAccountInfoModal);
    const editCompanyInfoModal = useSelector(selectEditCompanyInfoModal);
    const addExtraJobPostModal = useSelector(selectAddExtraJobPostModal);
    const videoUploadIssueModal = useSelector(selectVideoUploadIssueModal);
    const addExtraApplicantModal = useSelector(selectAddExtraApplicantModal);
    const incompleteProfileModal = useSelector(selectIncompleteProfileModal);
    const transactionDetailModal = useSelector(selectTransactionDetailModal);
    const copyJobLinkWarningModal = useSelector(selectCopyJobLinkWarningModal);
    const chooseCreditCardModal = useSelector(selectChooseCreditCardModalModal);
    const editJobExamDeadlineModal = useSelector(selectEditJobExamDeadlineModal);
    const confirmRemoveMemberModal = useSelector(selectConfirmRemoveMemberModal);
    const extraServicesPaymentModal = useSelector(selectExtraServicesPaymentModal);
    const personalEmailWarningModal = useSelector(selectPersonalEmailWarningModal);
    const confirmJoinOrganizationModal = useSelector(selectConfirmJoinOrganizationModal);
    const confirmLeaveOrganizationModal = useSelector(selectConfirmLeaveOrganizationModal);
    const recruitingInterviewReportModal = useSelector(selectRecruitingInterviewReportModal);
    const confirmCancelSubscriptionModal = useSelector(selectConfirmCancelSubscriptionModal);

    useEffect(() => {
        if (!profile?.companyLogo) return;
        dispatch(getLogoImageThunk(profile.companyLogo));
    }, [profile]);

    useEffect(() => {
        dispatch(getJobsThunk({}));
        dispatch(getUserInfoThunk());
        dispatch(getProfileDataThunk());
        dispatch(getUserAttributesThunk());
        dispatch(getStripeCustomerThunk({ action: 'get_customer' }))
    }, []);

    const options = {
        clientSecret: stripeCustomer?.client_secret
    };

    return (
        <WorkspaceLayout>
            <Outlet />
            {logOutModal && <LogOut />}
            {editCardModal && <EditCard />}
            {editEmailModal && <EditEmail />}
            {jobDetailModal && <JobDetail />}
            {plansModalShow && <PlansModal />}
            {deleteCardModal && <DeleteCard />}
            {changePlanModal && <ChangePlan />}
            {videoPlayerModal && <VideoPlayer />}
            {purchasePlanModal && <PurchasePlan />}
            {inviteMemberModal && <InviteMember />}
            {contactSalesModal && <ContactSales />}
            {contactAdminModal && <ContactAdmin />}
            {chooseCreditCardModal && <ChooseCard />}
            {preparingExamsModal && <PreparingExams />}
            {addExtraMemberModal && <AddExtraMember />}
            {examinerReportModal && <ExaminerReport />}
            {changePasswordModal && <ChangePassword />}
            {examShareGuideModal && <ExamShareGuide />}
            {confirmEndExamModal && <ConfirmEndExam />}
            {companyLogoModal && <UploadCompanyLogo />}
            {editCompanyInfoModal && <EditCompanyInfo />}
            {editAccountInfoModal && <EditAccountInfo />}
            {examinerProfileModal && <ExaminerProfile />}
            {editPhoneNumberModal && <EditPhoneNumber />}
            {addExtraJobPostModal && <AddExtraJobPost />}
            {videoUploadIssueModal && <VideoUploadIssue />}
            {addExtraApplicantModal && <AddExtraApplicant />}
            {transactionDetailModal && <TransactionDetail />}
            {incompleteProfileModal && <IncompleteProfile />}
            {copyJobLinkWarningModal && <CopyJobLinkWarning />}
            {editJobExamDeadlineModal && <EditJobExamDeadline />}
            {confirmRemoveMemberModal && <ConfirmRemoveMember />}
            {extraServicesPaymentModal && <ExtraServicesPayment />}
            {personalEmailWarningModal && <PersonalEmailWarning />}
            {confirmJoinOrganizationModal && <ConfirmJoinOrganization />}
            {confirmLeaveOrganizationModal && <ConfirmLeaveOrganization />}
            {confirmCancelSubscriptionModal && <ConfirmCancelSubscription />}
            {recruitingInterviewReportModal && <RecruitingInterviewReport />}
            {addNewCardModal && <Elements options={options} stripe={stripePromise}><AddNewCard /></Elements>}
        </WorkspaceLayout>
    );
};

export default Workspace;
